<h2 mat-dialog-title class="bg-primary text-center text-primary">{{title}}</h2>
<mat-dialog-content [style.width.px]="width">
	<mat-card class="bg-secondary">
		<mat-card-content>
			<p class="text-center text-secondary">
				{{message}}
			</p>
		</mat-card-content>
	</mat-card>

</mat-dialog-content>
<mat-dialog-actions align="center" class="flex-gap-10">
	<md-button color="primary" (click)="onConfirmClick()" tabindex="1">{{confirmButtonText}}</md-button>
	<md-button class="mr-2" color="warn" mat-raised-button mat-dialog-close tabindex="-1">{{cancelButtonText}}
	</md-button>
</mat-dialog-actions>